import { safeProduce as produce } from "~helpers/immer";

import * as at from "./actionTypes";

/**
 * @typedef {object} PlatformItem
 * @property {number} id
 * @property {string} platform_type
 * @property {object} credentials
 * @property {boolean} is_active
 * @property {number} project
 */

/**
 * @typedef {object} DataSourceItem
 * @property {number} id
 * @property {keyof import("~constants/eCommerceDataSourceType")} data_source_type
 * @property {boolean} is_active
 * @property {boolean} is_integrated
 * @property {PlatformItem} platform_integration
 * @property {string} status
 * @property {number} project
 */

/**
 * @typedef {object} ShopifyIntegrationItem
 * @property {number} id
 * @property {number} shop_id
 * @property {string} shop_name
 * @property {string} shop_domain
 * @property {object} metadata
 * @property {number} metadata.id
 * @property {null} metadata.zip
 * @property {null} metadata.city
 * @property {string} metadata.name
 * @property {string} metadata.email
 * @property {null} metadata.phone
 * @property {string} metadata.domain
 * @property {null} metadata.source
 * @property {string} metadata.country
 * @property {null} metadata.address1
 * @property {null} metadata.address2
 * @property {string} metadata.currency
 * @property {boolean} metadata.finances
 * @property {null} metadata.latitude
 * @property {null} metadata.province
 * @property {string} metadata.timezone
 * @property {null} metadata.longitude
 * @property {string} metadata.plan_name
 * @property {string} metadata.created_at
 * @property {string} metadata.shop_owner
 * @property {string} metadata.updated_at
 * @property {string} metadata.weight_unit
 * @property {string} metadata.country_code
 * @property {string} metadata.country_name
 * @property {boolean} metadata.county_taxes
 * @property {string} metadata.money_format
 * @property {null} metadata.tax_shipping
 * @property {boolean} metadata.has_discounts
 * @property {string} metadata.iana_timezone
 * @property {null} metadata.province_code
 * @property {string} metadata.customer_email
 * @property {boolean} metadata.has_gift_cards
 * @property {boolean} metadata.has_storefront
 * @property {string} metadata.primary_locale
 * @property {boolean} metadata.setup_required
 * @property {boolean} metadata.taxes_included
 * @property {string} metadata.myshopify_domain
 * @property {boolean} metadata.password_enabled
 * @property {string} metadata.plan_display_name
 * @property {null} metadata.google_apps_domain
 * @property {boolean} metadata.pre_launch_enabled
 * @property {number} metadata.primary_location_id
 * @property {boolean} metadata.eligible_for_payments
 * @property {boolean} metadata.checkout_api_supported
 * @property {string} metadata.money_in_emails_format
 * @property {boolean} metadata.multi_location_enabled
 * @property {null} metadata.google_apps_login_enabled
 * @property {string} metadata.money_with_currency_format
 * @property {boolean} metadata.transactional_sms_disabled
 * @property {null} metadata.auto_configure_tax_inclusivity
 * @property {string[]} metadata.enabled_presentment_currencies
 * @property {boolean} metadata.requires_extra_payments_agreement
 * @property {string} metadata.money_with_currency_in_emails_format
 * @property {boolean} metadata.marketing_sms_consent_enabled_at_checkout
 */

export const initState = {
  /** @type {PlatformItem[]} */
  eCommerceList: [],
  /** @type {DataSourceItem[]} */
  eCommerceDataSourceList: [],

  //Shopify State
  /** @type {ShopifyIntegrationItem[]} */
  shopifyIntegrations: [],
};

const popupSettings = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case at.SET_ECOMMERCE_LIST:
        draft.eCommerceList = action.payload;
        break;
      case at.SET_ECOMMERCE_DATA_SOURCE_LIST:
        draft.eCommerceDataSourceList = action.payload;
        break;
      case at.SET_SHOPIFY_INTEGRATIONS:
        draft.shopifyIntegrations = action.payload;
        break;
    }
  });

export default popupSettings;
